import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type OldUserState = {
	leadSocketUpdated: boolean
}

const initialState: OldUserState = {
	leadSocketUpdated: false,
}

export namespace OldUserNS {
	export type SetUpdated = PayloadAction<boolean>
}

export const oldUserSlice = createSlice({
	name: 'oldUser',
	initialState,
	reducers: {
		setUpdated: (state, action: OldUserNS.SetUpdated) => {
			state.leadSocketUpdated = action.payload
		},
	},
})
